import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Filters from '../../components/Filters/Filters';
import MobileNavigation from '../../components/UI/Mobile/MobileNavigation/MobileNavigation';

import classes from './Article.scss';

import Authentication from '../../containers/Authentication/Authentication';


class Article extends Component  {

    render() {
        let articleClass = [classes.Article];

        if (!this.props.isLoggedIn) {
            articleClass.push(classes.ArticleSlideZero);
        }
    
        if (!this.props.toggleArticle || this.props.location.pathname.includes('/flights/search') || this.props.location.pathname.includes('/reviews')) {
            articleClass.push(classes.ArticleSlideOne);
        } 
        if (this.props.slideArticle) {
            articleClass.push(classes.ArticleSlideTwo);
        }
        if(!this.props.tabletBookingEngine && window.innerWidth > 600 && window.innerWidth <= 900) {
            articleClass.push(classes.ArticleTablet);
        }

        const mainContent = (
            <React.Fragment>
                <div style={{display: this.props.filtersToggle ? 'block' : 'none'}} className="u-height100Percent">
                    <Filters />
                </div>
                <div style={{display: !this.props.filtersToggle ? 'block' : 'none'}} className="u-height100Percent">
                    <div className={classes.ArticleInner}>
                        <MobileNavigation/>
                        { this.props.isAuthenticating ? <Authentication/> : this.props.children }
                    </div>
                </div> 
            </React.Fragment>
        );                             
                                                    
        return (
            <div className={`${articleClass.join(' ')} u-boxShadowNormal`}>
                {mainContent}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      toggleArticle: state.navigation.sideNavigation,
      slideArticle: state.roundTripSummary.sidebar,
      filtersToggle: state.ui.filtersToggle,
      tabletBookingEngine: state.ui.tabletBookingEngine,
      isAuthenticating: state.auth.isAuthenticating,
      isLoggedIn: state.auth.isLoggedIn
    }
}

export default withRouter(connect(mapStateToProps)(Article));


// WEBPACK FOOTER //
// ./src/containers/Article/Article.js